import { Route } from '@angular/router';
import { AuthGuardCanActivate } from './auth/guards/auth.guard';
import { LoginGuardCanActivate } from './auth/guards/login.guard';
import { FirstLoginGuardCanActivate } from './auth/guards/first-login.guard';

export enum AppRoutes {
    Login = 'login',
    FirstLogin = 'first-login',
    Auctions = 'auctions',
    AuctionEnglish = 'auction/english',
    AuctionSealed = 'auction/sealed',
    Account = 'account',
    NotFound = '**',
}

export const appRoutes: Route[] = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: AppRoutes.Auctions,
    },
    {
        path: AppRoutes.Login,
        canActivate: [LoginGuardCanActivate],
        loadComponent: () => import('./auth/presentation/containers/login/login').then((m) => m.Login),
    },
    {
        path: AppRoutes.FirstLogin,
        canActivate: [FirstLoginGuardCanActivate],
        loadComponent: () => import('./auth/presentation/containers/first-login/first-login').then((c) => c.FirstLogin),
    },
    {
        path: AppRoutes.Auctions,
        canActivate: [AuthGuardCanActivate],
        loadComponent: () =>
            import('../features/trading-procedure-list/presentation/container/trading-procedure-list/trading-procedure-list.component').then(
                (c) => c.TradingProcedureList
            ),
    },
    {
        path: AppRoutes.AuctionEnglish,
        canActivate: [AuthGuardCanActivate],
        children: [
            {
                path: ':id',
                loadComponent: () =>
                    import('../features/auction-trade/presentation/container/auction-trade').then((c) => c.AuctionTrade),
            },
            {
                path: '',
                pathMatch: 'full',
                redirectTo: AppRoutes.Auctions,
            },
        ],
    },
    {
        path: AppRoutes.Auctions,
        canActivate: [AuthGuardCanActivate],
        children: [
            {
                path: '',
                pathMatch: 'full',
                loadComponent: () =>
                    import('../features/trading-procedure-list/presentation/container/trading-procedure-list/trading-procedure-list.component').then(
                        (c) => c.TradingProcedureList
                    ),
            },
        ],
    },
    {
        path: `${AppRoutes.Auctions}/:id`,
        pathMatch: 'full',
        redirectTo: `${AppRoutes.AuctionEnglish}/:id`,
    },
    {
        path: AppRoutes.AuctionSealed,
        canActivate: [AuthGuardCanActivate],
        children: [
            {
                path: ':id',
                loadComponent: () =>
                    import('../features/sealed-auction/presentation/container/sealed-auction.component').then(
                        (c) => c.SealedAuctionComponent
                    ),
            },
            {
                path: '',
                pathMatch: 'full',
                redirectTo: AppRoutes.Auctions,
            },
        ],
    },
    {
        path: AppRoutes.NotFound,
        loadComponent: () =>
            import('../features/not-found/presentation/container/not-found').then((c) => c.NotFound),
    },
] as const;
